import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { Shell } from "../components/Shell";
import { api, clearToken, getToken } from "../lib/api";
export function RequireSession({ role }) {
    const [user, setUser] = useState();
    useEffect(() => {
        if (!getToken(role)) {
            setUser(null);
            return;
        }
        api
            .me(role)
            .then(({ user }) => setUser(user))
            .catch(() => {
            clearToken(role);
            setUser(null);
        });
    }, [role]);
    if (user === undefined)
        return _jsx("div", { className: "center", children: "\u6B63\u5728\u8F7D\u5165\u8D26\u6237..." });
    if (!user)
        return _jsx(Navigate, { to: role === "ADMIN" ? "/admin/login" : "/login", replace: true });
    if (user.role !== role)
        return _jsx(Navigate, { to: user.role === "ADMIN" ? "/admin" : "/app", replace: true });
    return (_jsx(Shell, { user: user, children: _jsx(Outlet, {}) }));
}
